module.exports = __webpack_public_path__ + "img/local_gas_station_outlined.85b3e685.svg";